<script lang="ts">
  import "../app.css";
  import "@fontsource-variable/inter/wght.css";

  let { children } = $props();
</script>

{@render children()}
